const tableTitleServiceType = {
  title: 'Tipos de Serviços',
  placeholder: 'Pesquisar por tipo de serviço',
  Typography: 'Nenhum resultado encontrado'
};

export default tableTitleServiceType;
